import React from 'react';

const Legend: React.FC = () => {
  return (
    <div className="map-legend">
      <div className="legend-items">
        <div className="legend-item">
          <span className="color-box flight-area"></span>
          <span>Flight Area</span>
        </div>
        <div className="legend-item">
          <span className="color-box soft-geo-fence"></span>
          <span>Soft Geo-fence</span>
        </div>
        <div className="legend-item">
          <span className="color-box hard-geo-fence"></span>
          <span>Hard Geo-fence</span>
        </div>
        <div className="legend-item">
          <span className="color-box restricted-area"></span>
          <span>Restricted Area</span>
        </div>
      </div>
    </div>
  );
};

export default Legend;
